import React, { useEffect, useState } from "react";
import { SearchBar } from "../components/Person Recognition/searchBox";
import { ResultCrad } from "../components/Person Recognition/resultCards";
import authAxios from "../keycloak/authAxios";
import { useLocation } from "react-router-dom";

const PersonFound = () => {
  const [results, setResults] = useState([]);

  const location = useLocation();
  
  // on First Render/Mount only!
  useEffect(() => {
    var API_URL = `arshad?&flag=FOUND&limit=200&timestamp=${new Date().getTime()}`;

    setResults([]);
    authAxios.get(API_URL).then(res => {
      console.log(res.data.result)
      setResults(res.data.result);
    }).catch(err => {
        alert(err)
    });

  }, [location]);

  return (
    <>
      <SearchBar
        flag="FOUND"
        onSearch={(value) => {
          setResults(value);
        }}
      />

      <div style={{ marginTop: 30 }} align="center">
        <ResultCrad foundPersonResult={results} />
      </div>
    </>
  );
};

export default PersonFound;
